module.exports = __webpack_public_path__ + "img/2.62235a24.jpg";